/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 *
 * Jellyfin API
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
/**
 * The different kinds of messages that are used in the WebSocket api.
 * @export
 * @enum {string}
 */
const SessionMessageType = {
    ForceKeepAlive: 'ForceKeepAlive',
    GeneralCommand: 'GeneralCommand',
    UserDataChanged: 'UserDataChanged',
    Sessions: 'Sessions',
    Play: 'Play',
    SyncPlayCommand: 'SyncPlayCommand',
    SyncPlayGroupUpdate: 'SyncPlayGroupUpdate',
    Playstate: 'Playstate',
    RestartRequired: 'RestartRequired',
    ServerShuttingDown: 'ServerShuttingDown',
    ServerRestarting: 'ServerRestarting',
    LibraryChanged: 'LibraryChanged',
    UserDeleted: 'UserDeleted',
    UserUpdated: 'UserUpdated',
    SeriesTimerCreated: 'SeriesTimerCreated',
    TimerCreated: 'TimerCreated',
    SeriesTimerCancelled: 'SeriesTimerCancelled',
    TimerCancelled: 'TimerCancelled',
    RefreshProgress: 'RefreshProgress',
    ScheduledTaskEnded: 'ScheduledTaskEnded',
    PackageInstallationCancelled: 'PackageInstallationCancelled',
    PackageInstallationFailed: 'PackageInstallationFailed',
    PackageInstallationCompleted: 'PackageInstallationCompleted',
    PackageInstalling: 'PackageInstalling',
    PackageUninstalled: 'PackageUninstalled',
    ActivityLogEntry: 'ActivityLogEntry',
    ScheduledTasksInfo: 'ScheduledTasksInfo',
    ActivityLogEntryStart: 'ActivityLogEntryStart',
    ActivityLogEntryStop: 'ActivityLogEntryStop',
    SessionsStart: 'SessionsStart',
    SessionsStop: 'SessionsStop',
    ScheduledTasksInfoStart: 'ScheduledTasksInfoStart',
    ScheduledTasksInfoStop: 'ScheduledTasksInfoStop',
    KeepAlive: 'KeepAlive'
};

export { SessionMessageType };
